var _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuroBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 23.8273,
    rx: 24,
    ry: 23.8273,
    fill: "#94DDDF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2844_7027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3813 36.2371C22.7489 36.2371 17.9771 32.4904 16.44 27.3727H21.2592C21.7518 27.3727 22.1495 26.9768 22.1495 26.4863C22.1495 25.9958 21.7518 25.5998 21.2592 25.5998H16.0601C15.977 25.0207 15.9177 24.4298 15.9177 23.827C15.9177 23.2242 15.977 22.6333 16.0601 22.0541H24.8202C25.3128 22.0541 25.7105 21.6582 25.7105 21.1677C25.7105 20.6772 25.3128 20.2812 24.8202 20.2812H16.44C17.9771 15.1636 22.7489 11.4169 28.3813 11.4169C28.8739 11.4169 29.2715 11.021 29.2715 10.5305C29.2715 10.04 28.8739 9.64404 28.3813 9.64404C21.7578 9.64404 16.1729 14.1708 14.5882 20.2812H10.5762C10.0836 20.2812 9.68591 20.6772 9.68591 21.1677C9.68591 21.6582 10.0836 22.0541 10.5762 22.0541H14.2499C14.1787 22.6333 14.1372 23.2242 14.1372 23.827C14.1372 24.4298 14.1787 25.0207 14.2499 25.5998H10.5762C10.0836 25.5998 9.68591 25.9958 9.68591 26.4863C9.68591 26.9768 10.0836 27.3727 10.5762 27.3727H14.5882C16.1729 33.4832 21.7578 38.0099 28.3813 38.0099C28.8739 38.0099 29.2715 37.614 29.2715 37.1235C29.2715 36.633 28.8739 36.2371 28.3813 36.2371Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2844_7027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5856,
    height: 28.3659,
    fill: "white",
    transform: "translate(9.68591 9.64404)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroBlue);
export default __webpack_public_path__ + "static/media/euro-blue.53a4e5522842dede9ccf558657caeeb5.svg";
export { ForwardRef as ReactComponent };